/// <reference types="vite/client" />

// Alpine
import intersect from '@alpinejs/intersect'
import Alpine from 'alpinejs'

Alpine.plugin(intersect)

// Theme
import * as Theme from './default/theme'

// Components
import * as Components from './default/components'

window.itixBackendUrl =
    document.querySelector<HTMLHeadElement>('body > header[data-itix-backend-url]')?.dataset.itixBackendUrl || ''

// init JS when page is done loading
window.onload = () => {
    Theme.initIntersectObserver()
    Theme.initJSEssentials()
    Theme.initSpeculationRules()

    Components.initCollapsible()
    Components.initHeader()
    Components.initSubmenu()
    Components.initLightbox()
    Components.initHero()
    Components.initImages()
    Components.initImageSlider()
    Components.initNewsletter()
    Components.initNewsSlider()
    Components.initOrderArticle()
    Components.initPackageDatePicker()
    Components.initQuoteSlider()
    Components.initNewsSlider()
    Components.initShowOverview()
    Components.initShowSlider()
    Components.initShowStatus()
    Components.initSurveyForm()

    Alpine.start()
}

// Accept HMR as per: https://vitejs.dev/guide/api-hmr.html
if (import.meta.hot) {
    import.meta.hot.accept(() => {
        console.log('HMR')
    })
}

// Check if Alpine is ready, if not add class when it is
document.addEventListener('alpine:init', () => {
    document.body.classList.add('alpine-ready')
})
